export class Environment {
    public production: boolean;
    public apiUrl: string;
    public environmentName: string;
    public accountSiteUrl: string;
    public maintenanceUrl: string;
    public residenzUrl: string;
    public onboardingUrl: string;
    public zendeskUrl: string;
    public updatesUrl: string;
}